export default __webpack_public_path__ + "static/media/pattern-herringbone.8704dc85.jpeg";